import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { ButtonSize } from '../../../../models/BlockComponentValues/BlockComponentButton';

interface ButtonSizePickerProps {
  value: ButtonSize;
  onChangeSize: (value: ButtonSize) => void;
}

const ButtonSizePicker = ({ value, onChangeSize }: ButtonSizePickerProps) => (
  <Box>
    <Typography variant="caption" sx={{ width: '60px' }} className="text-bold" color="#495057">
      Size
    </Typography>
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, newValue: ButtonSize) => {
        if (newValue) {
          onChangeSize(newValue);
        }
      }}
      size="small"
      sx={{ marginLeft: 3 }}
    >
      <ToggleButton value={ButtonSize.SMALL} sx={{ paddingX: 2, paddingY: 1 }}>Small</ToggleButton>
      <ToggleButton value={ButtonSize.MEDIUM} sx={{ paddingX: 2, paddingY: 1 }}>Medium</ToggleButton>
      <ToggleButton value={ButtonSize.LARGE} sx={{ paddingX: 2, paddingY: 1 }}>Large</ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

export default ButtonSizePicker;
